import type { CotCircleType } from '../../types/community'
import { capabilitiesFor, taglineFor } from '../../lib/circleCapabilities'
import { SectionLabel } from '../ui/SectionLabel'
import { Pill } from '../ui/Pill'

/**
 * "What this circle type can do" — the static per-type capability matrix (COTC_Circles R2,
 * DESIGN §3.3). Rendered from the client capability constant so it needs no server round-trip.
 */
export function CapabilityPanel({ type }: { type: CotCircleType }) {
  const caps = capabilitiesFor(type)
  const tagline = taglineFor(type)

  return (
    <section className="mt-8">
      <SectionLabel className="mb-[6px] block">What this circle type can do</SectionLabel>
      <p className="mb-4 max-w-[58ch] text-[13.5px] leading-relaxed text-ink-muted">{tagline}</p>
      <div className="grid gap-3 [grid-template-columns:repeat(auto-fill,minmax(280px,1fr))]">
        {caps.map((c) => (
          <div key={c.title} className="rounded-[11px] border border-line-soft bg-paper-surface px-[17px] py-[15px]">
            <div className="mb-[6px] flex items-center justify-between gap-[10px]">
              <div className="text-[13.5px] font-semibold leading-tight text-ink">{c.title}</div>
              <Pill tone={c.on ? 'moss' : 'neutral'} className="flex-none uppercase tracking-label">
                {c.on ? 'ON' : 'OFF'}
              </Pill>
            </div>
            <div className="text-[12.5px] leading-relaxed text-ink-muted">{c.body}</div>
          </div>
        ))}
      </div>
    </section>
  )
}
